export const CURRENCY = {
	USDT: {
		symbol: 'USDT',
		name: 'Tether USD',
		icon: '/images/currency/usdt.svg',
	},
} as any;

export const COINGEKO_DATA = 'coingeko-data';
